"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DocumentSearchConfig = /** @class */ (function () {
    function DocumentSearchConfig(additionalFilterConfigs, categoryRelationConfig, additionalDocumentMetaDataFilterConfigs, additionalActionConfigs, subEntityFilterConfig, hasPreviewOption, hasDownloadOption, sortDocumentFields, excludedCategories, minQuerySymbols, searchDocumentsCount) {
        if (excludedCategories === void 0) { excludedCategories = []; }
        if (minQuerySymbols === void 0) { minQuerySymbols = 4; }
        if (searchDocumentsCount === void 0) { searchDocumentsCount = 100; }
        this.additionalFilterConfigs = additionalFilterConfigs;
        this.categoryRelationConfig = categoryRelationConfig;
        this.additionalDocumentMetaDataFilterConfigs = additionalDocumentMetaDataFilterConfigs;
        this.additionalActionConfigs = additionalActionConfigs;
        this.subEntityFilterConfig = subEntityFilterConfig;
        this.hasPreviewOption = hasPreviewOption;
        this.hasDownloadOption = hasDownloadOption;
        this.sortDocumentFields = sortDocumentFields;
        this.excludedCategories = excludedCategories;
        this.minQuerySymbols = minQuerySymbols;
        this.searchDocumentsCount = searchDocumentsCount;
    }
    return DocumentSearchConfig;
}());
exports.DocumentSearchConfig = DocumentSearchConfig;
//# sourceMappingURL=document-search.config.js.map